// Wait until DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
	// Utility to wait for required elements to exist
	function waitForElements(selector, callback) {
		const interval = setInterval(function () {
			if (document.querySelector(selector)) {
				clearInterval(interval);
				callback();
			}
		}, 100);
	}

	waitForElements('.product-form__buttons', function () {

		// Ensure jQuery is available
		if (typeof jQuery === 'undefined') {
			console.error('jQuery is not loaded.');
			return;
		}

		var $ = jQuery;

		// Remove extra shop buttons from PDP page 
		$('.product .product-form__buttons .shopify-payment-button').remove();

		// Sticky ATC button
		$('.product-form__buttons').addClass('sticky');

		// Show Back to Top button on scroll
		window.addEventListener('scroll', function () {
			if (window.scrollY > 300) {
				$('#backToTop').fadeIn();
			} else {
				$('#backToTop').fadeOut();
			}
		}, { passive: true });

		// Scroll to top on click
		$('#backToTop').on('click', function () {
			$('html, body').animate({ scrollTop: 0 }, 600);
			return false;
		});

		// Move quantity into button area
		var $quantity = $('.product-form__quantity');
		var $buttons = $('.product-form__buttons');
		var $priceOriginal = $('.no-js-hidden[role="status"]');

		if ($quantity.length && $buttons.length) {
			$quantity.prependTo($buttons);
		}

		// Move price into button on mobile
		function movePriceToMobile() {
			if (window.innerWidth <= 749) {
				$('.mobile-price').remove();
				var $submitBtn = $('.product-form__submit');
				$priceOriginal = $('.no-js-hidden[role="status"]');
				console.log($priceOriginal);
				if ($priceOriginal.length) {
					$priceOriginal.hide();
					var $clone = $priceOriginal.clone().addClass('mobile-price').show();
					$clone.find('.price').show();
					$submitBtn.append($clone);
				}
			}
		}

		// Restore price for desktop view
		function restorePrice() {
			$('.mobile-price').remove();
			$priceOriginal.show();
			$priceOriginal.find('.price').show();
		}

		// Remove USD text from price
		function removeUSD() {
			$('.price .price__regular .price-item').each(function () {
				var text = $(this).text();
				$(this).text(text.replace(/usd/i, '').trim());
			});
		}

		// Initial actions for mobile
		if (window.innerWidth <= 749) {
			movePriceToMobile();
			removeUSD();
		}

		// On resize
		window.addEventListener('resize', function () {
			if (window.innerWidth <= 749) {
				movePriceToMobile();
				removeUSD();
			} else {
				restorePrice();
			}
		});

		// On variant or size change
		$(document).on('change', '.product-form__input select, .product-form__input input[name="Size"]', function () {
			$('.mobile-price').remove();
			setTimeout(function () {
				movePriceToMobile();
				removeUSD();
				setBasePrices();
			}, 1000);
		});

		// update price based on quantity selection
		 var regular = {}, sale = {};
 
    function parsePrice($el) {
        var text = $el.text().trim();
        return {
            prefix: (text.match(/^[^\d]+/) || ["$"])[0].trim(),
            suffix: (text.match(/[^\d]+$/) || [""])[0].trim(),
            value: parseFloat(text.replace(/[^0-9.]/g, ""))
        };
    }
 
    function setBasePrices() {
        regular = parsePrice($(".price-per-piece-wrapper .price-item--regular:first"));	
		console.log(regular);
			
        sale = parsePrice($(".price-per-piece-wrapper .price-item--sale:first"));		
    }
 
    function updateCartPrice() {
		console.log(regular);
		
        var qty = parseInt($(".product-form__buttons .quantity__input").val()) || 1;
		console.log(qty);
		
        $(".price__regular .price-item--regular").text(regular.prefix + (regular.value * qty).toFixed(2) + " " + regular.suffix);
        $(".price__sale .price-item--sale, .price__sale .price-item--regular").text(sale.prefix + (sale.value * qty).toFixed(2) + " " + sale.suffix);
    }
 
    $(".product-form__buttons button[name='minus'], .product-form__buttons button[name='plus'], .quantity__input").on("click input", updateCartPrice);
   
	setBasePrices();


	});

	// move yotpo review button at left 
	jQuery(function ($) {
	const observer = new MutationObserver(function () {
		const widget = $('.product .yotpo-widget-instance');
		const button = $('.product .yotpo-new-review-button');
		const target = $('.product .yotpo-bottom-line-summary');

		if (widget.length && button.length && target.length) {
		button.appendTo(target);
		observer.disconnect(); // run once only
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
	});

	jQuery(function ($) {
	const observer = new MutationObserver(() => {
		const summary = $('.product .product-review-summaries-wrapper');
		const target  = $('.product .yotpo-header-container');

		if (!summary.length || !target.length) return;

		// Prevent duplicate insertion if Yotpo re-renders
		if (!target.find('.product-review-summaries-wrapper').length) {
		summary.appendTo(target);
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
	});

});